import React, { useRef, useState } from "react";
import { Typography, Stack, TextField, IconButton, Button, InputAdornment } from "@mui/material";
import NumberFormat from "react-number-format";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

interface Props {
  rates: string[];
  onCancel: () => void;
  onSubmit: (rates: string[]) => void;
}

export const EditRatesContent: React.FC<Props> = ({ rates, onCancel, onSubmit }) => {
  const [state, setState] = useState<string[]>(rates);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const handleChange = (index: number, value: string) => {
    const newRates = [...state];
    newRates[index] = value;
    setState(newRates);
  };

  const handleAdd = () => {
    setState([...state, ""]);
    setTimeout(() => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
      }
    }, 0);
  };

  const handleRemove = (index: number) => {
    const newRates = [...state];
    newRates.splice(index, 1);
    setState(newRates);
  };

  return (
    <Stack
      sx={{
        width: 270,
        maxHeight: 360,
        minHeight: 300,
        p: "20px",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "sm"
      }}
    >
      <Typography sx={{ pb: "20px", fontSize: "18px", fontWeight: 400 }}>Edit contribution rates</Typography>
      <Stack
        sx={{ flexGrow: 1, overflow: "auto", gap: "10px", p: "5px 8px 4px 0", maxHeight: "150px" }}
        ref={scrollContainerRef}
      >
        {state.map((rate, index) => (
          <Stack key={index} direction="row" spacing={2} alignItems="center">
            <Typography sx={{ minWidth: 60 }}>Year {index + 1}</Typography>
            <NumberFormat
              customInput={TextField}
              size="small"
              label="Rate"
              value={rate}
              allowNegative={false}
              isNumericString
              decimalScale={2}
              slotProps={{
                input: {
                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                }
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                handleChange(index, e.target.value)
              }
            />
            <IconButton sx={{ bgcolor: "#f5f6f7" }} size="sm" onClick={() => handleRemove(index)}>
              <ClearIcon />
            </IconButton>
          </Stack>
        ))}
      </Stack>

      <IconButton sx={{ bgcolor: "#f5f6f7" }} onClick={handleAdd}>
        <AddIcon />
      </IconButton>
      <Stack sx={{ flexDirection: "row", gap: "10px", justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => onSubmit(state)}>
          Edit
        </Button>
      </Stack>
    </Stack>
  );
};
